import { render } from "./InsightPage.vue?vue&type=template&id=586de0c0&scoped=true"
import script from "./InsightPage.vue?vue&type=script&lang=js"
export * from "./InsightPage.vue?vue&type=script&lang=js"

import "./InsightPage.vue?vue&type=style&index=0&id=586de0c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586de0c0"]])

export default __exports__